import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";

export function atLeastOneCheckboxCheckedValidator(minRequired = 1): any {
    return function validate(formGroup: FormGroup) {
        let checked = 0;

        Object.keys(formGroup.controls).forEach(key => {
            const control = formGroup.controls[key];

            if (control.value === true) {
                checked++;
            }
        });

        if (checked < minRequired) {
            return {
                requireCheckboxToBeChecked: true,
            };
        }

        return null;
    };
}

export class RegExpValidation {
    public errorName: string;
    public pattern: RegExp | string;
    
    constructor(errorName: string, pattern: RegExp | string) {
        this.errorName = errorName;
        this.pattern = pattern;
    }
}

export function regexMultiPatternValidator(regExpValidations: RegExpValidation[]): ValidatorFn {
    return (formControl: AbstractControl): ValidationErrors | null => {
        let validationError: ValidationErrors | null = null;

        regExpValidations.forEach((validation: RegExpValidation) => {
            let regEx = new RegExp(validation.pattern);

            if (!regEx.test(formControl.value)) {
                if (validationError == null) {
                    validationError = { DoesNotMatchPattern: { value: formControl.value } };
                }

                validationError[validation.errorName] = true;

            }
        })

        return validationError;
    };
}

export class CustomValidators {
    static stringIsNotEmpty(): ValidatorFn {
        return (formControl: AbstractControl): ValidationErrors | null => {
            let validationError: ValidationErrors | null = null;
    
            let cleanRegEx = new RegExp('(\W|\n|\r|\t|\s)', 'g')
            let cleanString = formControl.value.replaceAll(cleanRegEx, '');
            
            if (cleanString == '') {
                validationError = { StringIsEmpty: true }
            }
    
            return validationError;
        };
    }
}